import { Grid, Typography } from '@mui/material';
import { VariantItem } from '../variant-item';
import { styles } from './styles';
import { TOptionVariant } from 'widgets/selections/utils/types';

const POSSIBLE_APPROVED_OPTIONS_COUNT = 1;

interface IVariantsList {
  variants: (TOptionVariant & { key: string })[];
  isSelectionApproved: boolean;
  canEdit: boolean;
  canDelete: boolean;
  onDelete: (index: number) => void;
  onEdit: (index: number) => void;
}

export const VariantsList = ({
  variants,
  isSelectionApproved,
  canEdit,
  canDelete,
  onDelete,
  onEdit,
}: IVariantsList) => {
  if (!variants?.length) return null;

  return (
    <Grid sx={styles.container}>
      <Typography sx={styles.label}>Variant Type</Typography>
      <Grid sx={styles.content}>
        {variants.map((variant, index) => (
          <VariantItem
            key={variant.key}
            name={variant.name}
            count={isSelectionApproved ? POSSIBLE_APPROVED_OPTIONS_COUNT : variant.options.length}
            canEdit={canEdit}
            canDelete={canDelete}
            onDelete={() => onDelete(index)}
            onEdit={() => onEdit(index)}
          />
        ))}
      </Grid>
    </Grid>
  );
};
